// extracted by mini-css-extract-plugin
module.exports = {"base":"calculatorWrapper_base__KFpin","wrapper":"calculatorWrapper_wrapper__BVl5P"};